import { useEffect, useRef, useState } from "react";
import { apiRequest } from "../../shared/api/client";
import { financeSearchSchema } from "../../../shared/account-finance/account-finance-contract";
import type { z } from "zod";

export function useFinanceAccountSearchWorkspace(onSelect: (code: string) => void) {
  const [term, setTerm] = useState("");
  const [rows, setRows] = useState<z.infer<typeof financeSearchSchema>>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [searched, setSearched] = useState(false);
  const pending = useRef<AbortController | null>(null);
  useEffect(() => () => pending.current?.abort(), []);
  async function search() {
    if (loading || term.trim().length < 2) return;
    const controller = new AbortController(); pending.current?.abort(); pending.current = controller;
    setLoading(true); setError(null); setRows([]); setSearched(false);
    try {
      const raw = await apiRequest<unknown>(`/api/account-finance/search?q=${encodeURIComponent(term.trim())}`,
        { signal: AbortSignal.any([controller.signal, AbortSignal.timeout(15_000)]) });
      if (!controller.signal.aborted) { setRows(financeSearchSchema.parse(raw)); setSearched(true); }
    } catch (failure: unknown) { if (!controller.signal.aborted) setError(failure instanceof Error ? failure.message : "Cari araması başarısız."); }
    finally { if (!controller.signal.aborted) setLoading(false); }
  }
  return { term, rows, loading, error, searched, search,
    changeTerm: (value: string) => { setTerm(value); setRows([]); setSearched(false); },
    select: (code: string) => { onSelect(code); setRows([]); setSearched(false); } };
}
